var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrosshair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_Version",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stopdetail_1",
    transform: "translate(-868.000000, -664.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inactive_location--Copy",
    transform: "translate(864.000000, 660.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gps_fixed-24px",
    transform: "translate(4.285714, 4.285714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.71428571,3.80952381 C4.66190476,3.80952381 3.80952381,4.66190476 3.80952381,5.71428571 C3.80952381,6.76666667 4.66190476,7.61904762 5.71428571,7.61904762 C6.76666667,7.61904762 7.61904762,6.76666667 7.61904762,5.71428571 C7.61904762,4.66190476 6.76666667,3.80952381 5.71428571,3.80952381 Z M9.97142857,5.23809524 C9.75238095,3.25238095 8.17619048,1.67619048 6.19047619,1.45714286 L6.19047619,0.476190476 L5.23809524,0.476190476 L5.23809524,1.45714286 C3.25238095,1.67619048 1.67619048,3.25238095 1.45714286,5.23809524 L0.476190476,5.23809524 L0.476190476,6.19047619 L1.45714286,6.19047619 C1.67619048,8.17619048 3.25238095,9.75238095 5.23809524,9.97142857 L5.23809524,10.952381 L6.19047619,10.952381 L6.19047619,9.97142857 C8.17619048,9.75238095 9.75238095,8.17619048 9.97142857,6.19047619 L10.952381,6.19047619 L10.952381,5.23809524 L9.97142857,5.23809524 Z M5.71428571,9.04761905 C3.87142857,9.04761905 2.38095238,7.55714286 2.38095238,5.71428571 C2.38095238,3.87142857 3.87142857,2.38095238 5.71428571,2.38095238 C7.55714286,2.38095238 9.04761905,3.87142857 9.04761905,5.71428571 C9.04761905,7.55714286 7.55714286,9.04761905 5.71428571,9.04761905 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshair);
export default __webpack_public_path__ + "static/media/crosshair.612483770d6f1bc71e53a10c37bda1af.svg";
export { ForwardRef as ReactComponent };